import { createSlice } from '@reduxjs/toolkit';

const liveScoreStatusSlice = createSlice({
  name: 'historicalEvents',
  initialState : {},
  reducers: {
    aGetHistoricalEventsAction: () => {},
    aGetHistoricalEventsFailAction: () => {},
  },
});

export const {
  aGetHistoricalEventsAction,
  aGetHistoricalEventsFailAction,
} = liveScoreStatusSlice.actions;

// export const historicalEventsActionTypes = {
//   GET_HISTORICAL_EVENTS: 'GET_HISTORICAL_EVENTS',
//   GET_HISTORICAL_EVENTS_FAIL: 'GET_HISTORICAL_EVENTS_FAIL',
// };

// export const getHistoricalEventsAction = createAction(historicalEventsActionTypes.GET_HISTORICAL_EVENTS);
// export const getHistoricalEventsFailAction = createAction(historicalEventsActionTypes.GET_HISTORICAL_EVENTS_FAIL);
